import '~/assets/scss/reports.scss'

import Filters from '~/js/modules/filters';
import DropDown from '~/js/modules/drop-down';

window.addEventListener(`DOMContentLoaded`, () => {

  const filtersControls = document.querySelectorAll(`.js-filters-controls`);
  if (filtersControls.length) {
    filtersControls.forEach((fc, i) => new Filters(fc));
  }

  const dropDownBlocks = document.querySelectorAll(`.js-drop-down`);
  const dropDownSelects = document.querySelectorAll(`.js-drop-down-select`);
  const dropDownButtons = document.querySelectorAll(`.js-drop-down-btn`);
  if (dropDownBlocks.length && dropDownSelects.length && dropDownButtons.length &&
    dropDownBlocks.length === dropDownSelects.length &&
    dropDownBlocks.length === dropDownButtons.length) {
    dropDownBlocks.forEach((block, i) => new DropDown(block, dropDownSelects[i], dropDownButtons[i]));
  }
})
